import { ReactNode } from 'react';

import Icon from 'utils/icon';

interface InputProps {
	text: string | ReactNode;
	color?: 'red' | 'orange' | 'blue' | 'green' | 'white';
	small?: boolean;
	bordered?: boolean;
	iconName?: string;
	iconWidth?: number;
	iconHeight?: number;
	style?: React.CSSProperties;
	className?: string;
}

function StatusComponent({ text, color, small, bordered, iconName, iconWidth, iconHeight, style, className = '' }: InputProps) {
	return (
		<span
			className={`status ${color} ${small && 'small fw-semibold'} ${bordered && 'bordered'} ${
				iconName && 'd-flex align-items-center gap-1'
			} ${className}`}
			style={style}>
			{iconName && <Icon name={iconName} height={iconHeight} width={iconWidth} />}
			{text}
		</span>
	);
}

export default StatusComponent;
